import React, { lazy } from 'react';
import { Container } from './styled';
import BasketBallMatch from '../../basketball/Match';
import SoccerMatch from '../../soccer/Match';
import VolleyBallMatch from '../../volleyball/Match';
import HockeyMatch from '../../hockey/Match';
import FootballMatch from '../../football/Match';
import BaseballMatch from '../../baseball/Match';

const MatchWrapper = ({ sportsType, gameData }) => {
  let renderComponent = null;
  if (gameData.loading || !gameData.init) {
    return null;
  }
  switch (sportsType) {
    case 'baseball':
      renderComponent = <BaseballMatch gameData={gameData} />;
      break;
    case 'basketball':
      renderComponent = <BasketBallMatch gameData={gameData} />;
      break;
    case 'soccer':
      renderComponent = <SoccerMatch gameData={gameData} />;
      break;
    case 'volleyball':
      renderComponent = <VolleyBallMatch gameData={gameData} />;
      break;
    case 'hockey':
      renderComponent = <HockeyMatch gameData={gameData} />;
      break;
    case 'football':
      renderComponent = <FootballMatch gameData={gameData} />;
      break;
  }
  return <Container>{renderComponent}</Container>;
};

export default MatchWrapper;
